import { render, staticRenderFns } from "./CollectForm.vue?vue&type=template&id=55e23e3a&scoped=true&"
import script from "./CollectForm.vue?vue&type=script&lang=js&"
export * from "./CollectForm.vue?vue&type=script&lang=js&"
import style0 from "./CollectForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CollectForm.vue?vue&type=style&index=1&id=55e23e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e23e3a",
  null
  
)

export default component.exports